export const LAYOUT_COLOR_MODE = 'layoutColorMode';
export const STATIC_MENU = 'staticMenu';
export const LANGUAGE = 'language';
export const USER = 'user';
export const CHECKLIST_COLLAPSED_ITENS = 'checklistCollapsedItens';

export default {

  getLayoutColor(){
    return localStorage.getItem(LAYOUT_COLOR_MODE);
  },

  setLayoutColor(mode){
    return localStorage.setItem(LAYOUT_COLOR_MODE, mode);
  },

  getStaticMenu(){
    return localStorage.getItem(STATIC_MENU);
  },

  setStaticMenu(mode){
    return localStorage.setItem(STATIC_MENU, mode);
  },

  getLanguage(){
    return localStorage.getItem(LANGUAGE);
  },

  setLanguage(language){
    return localStorage.setItem(LANGUAGE, language);
  },

  getLoggedUser(){
    return JSON.parse(localStorage.getItem(USER));
  },

  setLoggedUser(user){
    return localStorage.setItem(USER, JSON.stringify(user));
  },

  getChecklistCollapsed(protocolId){
    return JSON.parse(localStorage.getItem(CHECKLIST_COLLAPSED_ITENS+protocolId));
  },

  setChecklistCollapsed(protocolId, checklistCollapsedItens){
    return localStorage.setItem(CHECKLIST_COLLAPSED_ITENS+protocolId, JSON.stringify(checklistCollapsedItens));
  },

};
